
import { mapState } from 'vuex'

export default {
  head() {
    return this.$metadata(this.story)
  },
  data() {
    return {
      story: {}
    }
  },
  mounted() {
    const eventData = {
      event: 'view_menu',
      currency: 'USD'
    }

    if (this.order && this.order.products) {
      eventData.items = this.order.products
      eventData.value = this.order.totals.total
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      ...eventData
    })

    this.$storybridge.on(['input', 'published', 'change'], (event) => {
      if (event.action === 'input') {
        if (event.story.id === this.story.id) {
          this.story.content = event.story.content
        }
      } else {
        window.location.reload()
      }
    })
  },
  async asyncData({ $storyapi, store, route }) {
    try {
      const { data } = await $storyapi.get('cdn/stories/order', {
        version: process.env.SB_VERSION
      })
      return {
        story: data.story
      }
    } catch (error) {
      console.error(error)
    }
  },
  computed: {
    ...mapState(['location', 'menu', 'order'])
  },
  async beforeMount() {
    this.$store.commit('setLoading', true)

    // Set location
    const location = await this.$api.getLocation(this.$route.params.mid, true)
    if (location) {
      this.$store.commit('setLocation', location)
    } else {
      this.$router.push('/')
      return
    }

    // Redirect if location is not available
    if (location.available === false) {
      console.error('This location is not currently accepting orders')
      this.$router.push('/locations')
      return
    }

    // Set menu
    const menu = await this.$api.getMenu(true, {
      menuId: this.$route.params.mid
    })
    if (!menu) {
      console.error('Menu not found', this.menu)
      this.$router.push('/locations')
      return
    } else {
      this.$store.commit('setMenu', menu)
    }

    // Transfer or create order
    if (this.order && this.order.menu_id != location.menu_id) {
      await this.$api.transferOrder()
    } else {
      await this.$api.createOrder()
    }

    // Handle query params
    if (this.$route.query) {
      // Referral logic
      const rwgToken = this.$route.query?.rwg_token
      if (rwgToken) {
        const payload = {
          source: 'rwg_token',
          token: rwgToken
        }
        await this.applyCartReferral(payload)
      }

      // Handoff logic
      const { handoff } = this.$route.query
      if (handoff) {
        if (['dispatch','delivery'].includes(handoff)) {
          this.$router.push('/locations?mode=delivery')
          return
        } else {
          await this.$api.setHandoff(handoff)
        }
      }
    }

    // Redirect to order because this _mid page is buggy
    this.$router.push('/order')

    this.$store.commit('setLoading', false)
  },
  methods: {
    async applyCartReferral(payload) {
      if (!this.order) {
        await this.$api.createOrder()
      }

      const response = this.$axios({
        method: 'put',
        url: `/api/v2/carts/${this.order.id}/referral`,
        data: payload
      })

      if (response) {
        this.$store.commit('setErrors', response)
        return false
      } else {
        return true
      }
    }
  }
}
